"use client";
import styled from "@emotion/styled";
import { Spinner } from "@nextui-org/react";
import Link from "next/link";
import {
  useParams,
  usePathname,
  useRouter,
  useSearchParams,
} from "next/navigation";
import React, { useEffect, useState } from "react";
import { getBrands } from "../../../actions/brands";
import { getCategoriesNew } from "../../../actions/category";
import { FilterHeading, FiltersDetails } from "../../../components/molecules";
import { SearchIcon } from "../../../components/molecules/SearchIcon";
import ToggleSkeleton from "../../../components/skeletons/ToggleSkeleton";
import { useDictionary } from "../../../context/dictionaryProvider";
import { debounce } from "../../../lib/util";
import ButtonCheckbox from "./ButtonCheckbox";
import clearIcon from "../../../../public/icons/clearIcon.svg";
import Image from "next/image";

const Filters = ({
  showTabs = false,
  onClose,
  hideTopClear,
  preventDefault,
  applyFilter,
  hideField = [],
  skeleton = 4,
  className,
  defaultCategory,
}) => {
  const dict = useDictionary();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [Brands, setBrands] = useState([]);
  const [categories, setCategory] = useState([]);
  // const category = searchParams?.get("category") || defaultCategory;

  useEffect(() => {
    // get Brands

    const fetchBrands = async () => {
      setLoading(true);
      const [categories, brands] = await Promise.all([
        getCategoriesNew(null, params, 30),
        getBrands({ params, limit: 100 }),
      ]);
      setBrands(brands?.data);
      setCategory(categories?.data);
      setLoading(false);
    };

    fetchBrands();
  }, [params]);

  const handleSearch = debounce((e) => {
    const term = e.target.value;
    const params = new URLSearchParams(searchParams);
    if (term) {
      params.set("query", term);
    } else {
      params.delete("query");
    }
    if (applyFilter) applyFilter("query", term);
    if (!preventDefault) {
      replace(`${pathname}?${params.toString()}`, { scroll: false });
    }
  }, 800);

  const handleClear = (e) => {
    e.preventDefault();
    replace(pathname, { scroll: false });
    if (onClose) {
      onClose();
    }
  };

  const handleFilter = (key, value) => {
    const params = new URLSearchParams(searchParams);
    const currentValue = params.get(key)?.split(",") || [];

    const updatedValue = currentValue.includes(value)
      ? currentValue.filter((val) => val !== value)
      : [...currentValue, value];

    if (updatedValue.length > 0) {
      params.set(key, updatedValue.join(","));
    } else {
      params.delete(key);
    }
    if (applyFilter) applyFilter(key, value);
    if (!preventDefault) {
      replace(`${pathname}?${params.toString()}`, { scroll: false });
    }
  };

  // const handleTabs = (key) => {
  //   const params = new URLSearchParams(searchParams);
  //   if (key != "all") {
  //     params.set("category", key);
  //   } else {
  //     params.delete("category");
  //   }
  //   replace(`${pathname}?${params.toString()}`, { scroll: false });
  // };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div>
      {!hideField.includes("head") && (
        <FilterHeading>
          <h3 className="text-[18px] font-bold mb-2">
            {dict.courses.filters.title}
          </h3>
          {!hideTopClear ? (
            <Link
              prefetch={false}
              className="text-[14px] text-[#868686] underline underline-offset-2"
              href="#"
              onClick={handleClear}
            >
              {dict.courses.filters.clear}
            </Link>
          ) : (
            <button onClick={onClose}>
              <Image src={clearIcon} height={24} width={24} alt="clearIcon" />
            </button>
          )}
        </FilterHeading>
      )}
      <FiltersDetails>
        {/* {showTabs && (
          <Tabs
            aria-label="Options"
            fullWidth
            className="mt-10"
            onSelectionChange={handleTabs}
            selectedKey={category || "all"}
          >
            <Tab key="all" title="Any" />
            <Tab key="it" title="IT" />
            <Tab key="management" title="Management" />
          </Tabs>
        )} */}
        {/* {!hideField.includes("keyword") && (
          <FilterKeywords className="mt-8 mb-8">
            <h3 className="text-[14px] font-bold text-black mb-2">
              {dict.courses.filters.keywords}
            </h3>
            <SearchInput
              placeholder="Search for any courses"
              size="md"
              endContent={<SearchIcon size={25} className="sss" />}
              type="search"
              className="h-11"
              classNames={{
                base: "searchGroup blogSearchGroup w-full md:w-[530px] max-w-full",
                inputWrapper: "searchInput",
                mainWrapper: "inputGroup",
                input: "dfd",
              }}
              defaultValue={searchParams.get("query")?.toString()}
              onChange={handleSearch}
            />
          </FilterKeywords>
        )} */}
        {!hideField.includes("category") && (
          <FilterBrand className="mb-4">
            {categories?.length > 0 && (
              <h3 className="text-[14px] font-bold text-black mb-2">
                {dict?.category}
              </h3>
            )}
            <ItemsBoxContainer
              className={className ? className : ""}
              style={{
                maxHeight: "calc(100vh - 540px)",
                overflowY: "auto",
                minHeight: "80px",
              }}
            >
              {categories?.map((cat, index) => (
                <React.Fragment key={index}>
                  <ButtonCheckbox
                    label={cat.name}
                    value={cat.slug}
                    isChecked={searchParams.get("category")?.includes(cat.slug)}
                    onClick={(value) => handleFilter("category", value)}
                  />
                </React.Fragment>
              ))}
            </ItemsBoxContainer>
          </FilterBrand>
        )}
        {!hideField.includes("brand") && (
          <FilterCate className="">
            {Brands?.length > 0 && (
              <h3 className="text-[14px] font-bold text-black mb-2">
                {dict?.byBrand}
              </h3>
            )}
            <ItemsBoxContainer
              className={className ? className : ""}
              style={{
                maxHeight: "calc(100vh - 540px)",
                overflowY: "auto",
                minHeight: "80px",
              }}
            >
              {!loading.brand ? (
                Brands?.map((brand, index) => (
                  <React.Fragment key={index}>
                    <ButtonCheckbox
                      label={brand.name}
                      value={brand.slug}
                      isChecked={searchParams
                        .get("brands")
                        ?.includes(brand.slug)}
                      onClick={(value) => handleFilter("brands", value)}
                    />
                  </React.Fragment>
                ))
              ) : (
                <ToggleSkeleton length={skeleton} />
              )}
            </ItemsBoxContainer>
          </FilterCate>
        )}
      </FiltersDetails>
    </div>
  );
};

export default Filters;

const ItemsBoxContainer = styled.div``;
const FilterBrand = styled.div``;
const FilterCate = styled.div``;
